const validateEmailChange = (input: any) => {
  if (input?.length) {
    const isValid = String(input)
      .toLowerCase()
      .match(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/);
    return !!isValid;
  }

  return false;
};

export default validateEmailChange;
